/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_Auto_LinkInputs */

const en_simple_mulai_auto_link = /** @type {(inputs: Simple_Mulai_Auto_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the automatic route`)
};

const id_simple_mulai_auto_link = /** @type {(inputs: Simple_Mulai_Auto_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat jalur otomatis`)
};

/**
* | output |
* | --- |
* | "See the automatic route" |
*
* @param {Simple_Mulai_Auto_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_auto_link = /** @type {((inputs?: Simple_Mulai_Auto_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_Auto_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_auto_link(inputs)
	return en_simple_mulai_auto_link(inputs)
});